import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Grid } from '@hub/grid';
import { Text } from '@hub/text';
import { CoreContainer } from '@hub/core-container';
import { Box } from '@hub/box';
import { H3 } from '@hub/heading';
import { Link } from '@hub/link';
import { sortBy } from 'lodash';
import getStoreMapLink from '@scentregroup/shared/helpers/get-store-map-link';
import Tile from './tile';
import MagicLink from '../magic-link';
import { MenuLink } from '@hub/navigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const StoreTile = _ref => {
  let {
    title,
    url,
    mapUrl,
    address,
    landmark,
    isLastChild
  } = _ref;
  return /*#__PURE__*/_jsxs(Tile, {
    isLastChild: isLastChild,
    sxInner: {
      gap: ['spacing-sm', null, 'spacing-md']
    },
    "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Tile",
    children: [/*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(MagicLink, {
        href: url,
        "data-id": "tile-list_retailer-stores-tile-list_StoreTile_MagicLink",
        children: /*#__PURE__*/_jsx(Text, {
          isBodyText: true,
          align: "center",
          tone: "strong",
          decoration: "underline",
          "data-id": "tile-list_retailer-stores-tile-list_StoreTile_MagicLink_Text",
          children: title
        })
      }), /*#__PURE__*/_jsx(Box, {
        minHeight: 'size-5',
        paddingTop: "spacing-sm",
        paddingLeft: "spacing-sm",
        paddingRight: "spacing-sm",
        "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box",
        children: /*#__PURE__*/_jsx(Text, {
          isBodyText: true,
          noOfLines: 1,
          align: "center",
          "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box_Text",
          children: address
        })
      }), /*#__PURE__*/_jsx(Box, {
        paddingLeft: "spacing-sm",
        paddingRight: "spacing-sm",
        paddingBottom: "spacing-sm",
        "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box",
        children: /*#__PURE__*/_jsx(Text, {
          isBodyText: true,
          noOfLines: 1,
          align: "center",
          "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box_Text",
          children: landmark
        })
      })]
    }), mapUrl && /*#__PURE__*/_jsx(Link, {
      href: mapUrl,
      "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Link",
      children: /*#__PURE__*/_jsx(Text, {
        isBodyText: true,
        decoration: "underline",
        "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Link_Text",
        children: "See on map"
      })
    })]
  }, title);
};
const RetailerStoresTileList = _ref2 => {
  let {
    retailer,
    stores,
    state
  } = _ref2;
  const unsortedStoreTilePropsList = stores.map(store => ({
    title: store.centre.title,
    address: store.physicalAddress,
    landmark: store.landmarkDescription,
    url: "/".concat(store.centre.slug, "/store/").concat(store.id, "/").concat(store.slug),
    mapUrl: getStoreMapLink(store.centre, _objectSpread(_objectSpread({}, store), {}, {
      sys: {
        id: store.id
      }
    }))
  }));
  const tilePropsList = sortBy(unsortedStoreTilePropsList, ['title', 'address', 'landmark']);
  return /*#__PURE__*/_jsx(CoreContainer, {
    "data-id": "tile-list_retailer-stores-tile-list_StoreTile_CoreContainer",
    children: /*#__PURE__*/_jsxs(Box, {
      "data-id": "tile-list_retailer-stores-tile-list_StoreTile_CoreContainer_Box",
      children: [/*#__PURE__*/_jsxs(H3, {
        sx: {
          marginBottom: 'spacing-md'
        },
        align: 'center',
        "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box_H3",
        children: ["Visit ", retailer.title, " in ", state ? state : 'centre']
      }), /*#__PURE__*/_jsx(Grid, {
        templateColumns: ['repeat(auto-fit, 45%)', 'repeat(auto-fit, 30%)', 'repeat(auto-fit, 22%)', 'repeat(auto-fit, 15%)'],
        templateRows: '1fr, 1fr, 1fr',
        rowGap: ['spacing-sm', 'spacing-sm', 'spacing-md', 'spacing-md'],
        columnGap: ['spacing-sm', 'spacing-sm', 'spacing-none', 'spacing-none'],
        sx: {
          justifyContent: 'center',
          alignItems: 'stretch',
          gridAutoRows: '1fr',
          justifyItems: 'stretch',
          ['@media screen and (min-width: 48em) and (max-width: 62em)']: {
            ['*:nth-child(4n)']: {
              borderRightWidth: 0
            }
          },
          ['@media screen and (min-width: 62em) ']: {
            ['*:nth-child(6n)']: {
              borderRightWidth: 0
            }
          }
        },
        "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box_Grid",
        children: tilePropsList.map((props, key) => /*#__PURE__*/_createElement(StoreTile, _objectSpread(_objectSpread({}, props), {}, {
          isLastChild: tilePropsList.length - 1 === key,
          key: key,
          "data-id": "tile-list_retailer-stores-tile-list_StoreTile"
        })))
      }), state && retailer.id ? /*#__PURE__*/_jsx(Box, {
        sx: {
          marginTop: 'spacing-md'
        },
        "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box",
        children: /*#__PURE__*/_jsx(MenuLink, {
          href: "/store/".concat(retailer.id, "/").concat(retailer.slug),
          sx: {
            display: 'block',
            width: 'size-lg',
            margin: '0 auto'
          },
          "data-id": "tile-list_retailer-stores-tile-list_StoreTile_Box_MenuLink",
          children: /*#__PURE__*/_jsx(Text, {
            fontSize: "font-md",
            align: "center",
            decoration: "underline",
            "data-id": "tile-list_retailer-stores-tile-list_StoreTile_MenuLink_Text",
            children: "See all centres"
          })
        })
      }) : null]
    })
  });
};
export default RetailerStoresTileList;